export const STORAGE_UNAVAILABLE_MESSAGE =
  "Le stockage local du navigateur n'est pas disponible. Vérifiez que le mode privé ou les restrictions du navigateur ne bloquent pas IndexedDB.";

export function storageErrorMessage(fallback: string, error: unknown) {
  if (error instanceof Error && error.message) {
    return `${fallback} ${error.message}`;
  }

  return fallback;
}
